import { verifyInputs, loadWidgetData, createBannerElement } from "./helper";
import { loadTexts, logEvent } from "../widget";
import { shouldBeHiddenOnPage } from "../utilities";

/**
 * Renders a Beratungshero banner.
 * @param {HTMLElement} anchor - The anchor element into which it will be rendered.
 * @param {object} config - The config object.
 * @param {string} config.lang - The current page language.
 * @param {("bikeworld"|"doitgarden"|"micasa"|"melectronics"|"sportx")} config.tenant - The tenant that to use. This will be used to determine the correct colors and consultant assets.
 * @returns {void}
 * @example
 * renderBanner(anchor, config);
 * @example
 * renderBanner(anchor, { lang: "de", tenant: "bikeworld" });
 */
export default async function renderBanner(anchor, config) {
  verifyInputs(anchor, config);

  try {
    const { lang, tenant } = config;
    if (shouldBeHiddenOnPage(tenant)) return;

    const {
      consultant,
      duringOfficeHours,
      consultantAvailable,
      tenant: tenantData
    } = await loadWidgetData(lang, tenant);

    const { touchpoints } = tenantData;
    if (
      touchpoints &&
      touchpoints.banner &&
      touchpoints.banner.enabled !== undefined &&
      !touchpoints.banner.enabled
    )
      return;

    if (!duringOfficeHours || !consultantAvailable) return;
    if (!consultant || !consultant._id) throw new Error("No consultant found");

    let avatarImageUrl = consultant.imageAvatar;
    if (avatarImageUrl.indexOf("https://") === 0) {
      avatarImageUrl = avatarImageUrl.replace("upload/", "upload/w_240/");
    } else {
      avatarImageUrl = window.BH_URL + avatarImageUrl;
    }

    const banner = createBannerElement(
      loadTexts(lang),
      tenant,
      lang,
      avatarImageUrl,
      consultant
    );

    anchor.appendChild(banner);

    const moreLink = document.querySelector("#beratungshero-banner-video");
    moreLink.onclick = function () {
      logEvent("BUTTON_BANNER_CLICKED");
    };
  } catch (err) {
    console.error(err);
  }
}
